import { Link } from "react-router-dom"
import "./Error.scss"

export default function ErrorElementAdm() {


  return (
    <div className="lost-and-found-container">
      <div className="lost-and-found-content">
        {/* Icon */}
        <div className="icon-wrapper">
          <i style={{color:"green",fontSize:"64px"}}
           className="ri-compass-discover-line text-8xl text-emerald-500"></i>
        </div>

        
        <h1 className="heading">Lost & Found</h1>

        
        <p className="subtitle">It seems you've discovered something lost in the digital wilderness.</p>

        
        <div className="error-box">
          <span className="error-label">Error:</span>
          <span className="error-message">Page not found or an error occurred</span>
        </div>

        <div className="button-group">
          <Link to="/admin" className="btn btn-primary">
            <i className="ri-home-4-line text-xl"></i>
            Return Home
          </Link>
        </div>

       
        <p className="footer-text">Don't worry, even the best explorers get lost sometimes.</p>
      </div>

      
      <div className="decoration"></div>
    </div>
  )
}